module.exports = __webpack_public_path__ + "3e703a2ea4c94d296ccfef6eede102ac.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/group/White1.jpg
// module id = 3
// module chunks = 0